//"use strict";
var cx = require("classnames");
var PromptConfirmButtonGroup = require("app/shared/components/Prompt/prompt-confirm-button-group");
var Prompt = require("app/shared/components/Prompt/prompt");
var Tooltip = require("app/shared/components/Tooltip/tooltip");
var Button = require("app/shared/components/Button/button");

var config = require("app/util/config/config");
var betaURL = require("app/util/config/beta-url");
var TRIAL_DAYS = config.app.trialDays;

var GoogleCalendarActivation = React.createClass({
  propTypes: {
    callingAPI: React.PropTypes.bool.isRequired,
    email: React.PropTypes.string.isRequired,
    handleActivate: React.PropTypes.func.isRequired,
    handleRemove: React.PropTypes.func.isRequired,
    hasIntegration: React.PropTypes.any,
    handleViewSettings: React.PropTypes.func.isRequired,
    viewSettings: React.PropTypes.bool.isRequired,
    isFeatureAvailable: React.PropTypes.bool.isRequired,
    isTrialDone: React.PropTypes.bool.isRequired
  },
  toggleViewSettings: function(){
    this.props.handleViewSettings(!this.props.viewSettings);
  },
  displayActivateButton: function() {
    if (this.props.isFeatureAvailable) {
      return (
        <ActivateButton  onClick={this.props.handleActivate} callingAPI={this.props.callingAPI} />
      );
    } else {
      return <BuyPlanProButton isTrialDone={this.props.isTrialDone} />;
    }
  },
  displayButtons: function() {
    if (this.props.hasIntegration == false) {
      return (
        <div className="mt-40">
          {this.displayActivateButton()}
        </div>
      );
    } else {
      return (
        <div className="fs-14 mt-40">
          <label>Vínculado com:</label>
          <span className="d-f align-center">
            <input ref="emailAccountGoogleCalendar"
              type="text" className="googleCalendar-activation-emailAccountInput w-220 mr-10"
              value={this.props.email} readOnly/>
            <DeactivateButton callingAPI={this.props.callingAPI} onClick={this.props.handleRemove}/>
            <span className="ml-10">
              <Button type="default" onClick={this.toggleViewSettings}>
                Configurações
              </Button>
            </span>
          </span>
        </div>
      );
    }
  },
  render: function() {
    return <div>{this.displayButtons()}</div>;
  }
});

var BuyPlanProButton = React.createClass({
  renderBuyButton: function() {
    return (
      <Button type="primary" href={{url: betaURL() + '/plans', name:"_top"}}>
        Assinar um Plano Pro
      </Button>
    );
  },
  renderTrialButton: function() {
    return (
        <Button type="success" href={{url: betaURL() + '/plans', name:"_top"}}>
          Experimentar por {TRIAL_DAYS} dias
        </Button>
    );
  },
  render: function() {
    if(this.props.isTrialDone) {
      return this.renderBuyButton();
    } else {
      return this.renderTrialButton();
    }
  }
});

var DeactivateButton = React.createClass({
  render: function() {
    var promptProps = {
      text:"Deseja excluir esta integração?",
      buttonText: "Excluir",
      buttonClasses: "btn btn-danger fw-400",
      type: "confirm",
      onConfirm: this.props.onClick,
    };
    return (
      <PromptConfirmButtonGroup>
        <Prompt {...promptProps} />
        <Button type="danger" onClick={this.props.onClick} disabled={this.props.callingAPI}>
          {this.props.callingAPI?"Removendo":"Remover"}
        </Button>
      </PromptConfirmButtonGroup>
    );
  }
});

var ActivateButton = React.createClass({
  render: function() {
    return (
      <Button type="primary" onClick={this.props.onClick} disabled={this.props.callingAPI}>
        {this.props.callingAPI?"Ativando":"Ativar"}
      </Button>
    );
  }
});

module.exports = GoogleCalendarActivation;



// WEBPACK FOOTER //
// ./app/screens/Integration/components/GoogleCalendar/google-calendar-activation.jsx